import { Navigate, useParams } from 'react-router-dom';
import { useGetTypeRegimen } from '@/shared/actions/erp';
import { LoaderComponent } from '@/shared/components/ui';
import { SaveTypeRegimenes } from '../../shared/saveRegimenes';
import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';

export interface UpdateTypeRegimenInterface{}

const UpdateTypeRegimen: React.FC<UpdateTypeRegimenInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_view_tiporegimen);

    const { id } = useParams();
    const { data, isLoading } = useGetTypeRegimen(id!);
    if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_tipo_regimen) return <Navigate to="/parametrizacion/tipo-regimenes" />;

  return <SaveTypeRegimenes titlePage="Editar Regímenes" editTypeRegimens={data.data} />;
};

export default UpdateTypeRegimen;